import type { RepositoryView } from "@baton/contracts";
import { Modal } from "./components/modal.js";
import type { DashboardApi } from "./api.js";
import { RepositoryAccess } from "./repository-access.js";

/** Admin-only: link a repository the viewer's GitHub identity can already reach. */
export function RepositoryPicker(props: {
  open: boolean;
  onClose(): void;
  repositories: RepositoryView[];
  working: boolean;
  onAdd(repositoryId: string): void;
  api: DashboardApi;
  onRefresh(): Promise<void>;
}) {
  return <Modal open={props.open} onClose={props.onClose} title="Link a repository">
    <div className="repository-picker" data-testid="repository-picker">
      <p className="muted">Only repositories mirrored from GitHub for your identity appear here. Members see a repository block only when GitHub lists them as collaborators.</p>
      {props.repositories.length === 0 && <p className="empty compact">No other accessible repositories.</p>}
      <ul className="member-list">
        {props.repositories.map((repository) => <li className="control-row" key={repository.id}>
          <span>{repository.ownerHandle}/{repository.name} <small>{repository.permission} · {repository.defaultBranch}</small></span>
          <button type="button" disabled={props.working} onClick={() => props.onAdd(repository.id)}>Add</button>
        </li>)}
      </ul>
      {props.open && <RepositoryAccess api={props.api} onRefresh={props.onRefresh} />}
    </div>
  </Modal>;
}
